import React from 'react';
import { Inbox, Star, Hash, Lock, Plus, MessageCircle } from 'lucide-react';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { initialsOf } from '@/components/contacts/ContactCard';

const Row = ({ active, onClick, icon, label, count, testid, muted }) => (
  <button type="button" onClick={onClick} className={`flex w-full items-center gap-2 rounded-xl px-2.5 py-1.5 text-sm transition-colors ${active ? 'bg-primary text-primary-foreground' : muted ? 'text-muted-foreground hover:bg-muted hover:text-foreground' : 'hover:bg-muted'}`} data-testid={testid}>
    {icon}
    <span className={`flex-1 truncate text-left ${count > 0 && !active ? 'font-semibold' : ''}`}>{label}</span>
    {count > 0 && <span className={`rounded-full px-1.5 text-[10px] font-semibold ${active ? 'bg-white/20 text-white' : 'bg-primary text-primary-foreground'}`} data-testid={`${testid}-badge`}>{count}</span>}
  </button>
);

const SectionTitle = ({ label, onAdd, testid }) => (
  <div className="mt-4 mb-1 flex items-center px-2.5">
    <span className="flex-1 text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">{label}</span>
    {onAdd && <button type="button" onClick={onAdd} className="rounded-md p-0.5 text-muted-foreground hover:bg-muted hover:text-foreground" data-testid={testid} aria-label="add"><Plus size={14} /></button>}
  </div>
);

export const ChannelSidebar = ({ data, box, channelId, go, onNewChannel, onNewDm, lang }) => {
  const id = lang === 'id';
  const channels = (data?.channels || []).filter((c) => c.kind !== 'dm');
  const dms = (data?.channels || []).filter((c) => c.kind === 'dm');
  return (
    <nav className="flex h-full flex-col overflow-y-auto px-2 py-3" data-testid="discuss-sidebar">
      <Row active={box === 'inbox'} onClick={() => go('inbox')} icon={<Inbox size={15} />} label={id ? 'Kotak masuk' : 'Inbox'} count={data?.inbox_count || 0} testid="discuss-nav-inbox" />
      <Row active={box === 'starred'} onClick={() => go('starred')} icon={<Star size={15} />} label={id ? 'Berbintang' : 'Starred'} count={0} testid="discuss-nav-starred" />
      <SectionTitle label={id ? 'Kanal' : 'Channels'} onAdd={onNewChannel} testid="discuss-add-channel" />
      {channels.map((c) => (
        <Row key={c.id} active={box === 'channel' && channelId === c.id} onClick={() => go('channel', c.id)} muted={!c.is_member}
          icon={c.kind === 'group' ? <Lock size={14} /> : <Hash size={14} />} label={c.name} count={c.unread_count} testid={`discuss-channel-${c.id}`} />
      ))}
      <SectionTitle label={id ? 'Pesan langsung' : 'Direct messages'} onAdd={onNewDm} testid="discuss-add-dm" />
      {dms.map((c) => (
        <Row key={c.id} active={box === 'channel' && channelId === c.id} onClick={() => go('channel', c.id)}
          icon={<Avatar className="h-5 w-5"><AvatarFallback className="bg-[rgba(34,197,171,0.2)] text-[hsl(var(--pillot-mint))] text-[9px] font-semibold">{initialsOf(c.display_name)}</AvatarFallback></Avatar>}
          label={c.display_name} count={c.unread_count} testid={`discuss-dm-${c.id}`} />
      ))}
      {dms.length === 0 && <button type="button" onClick={onNewDm} className="mx-2.5 mt-1 flex items-center gap-1.5 rounded-xl border border-dashed border-border px-2 py-1.5 text-xs text-muted-foreground hover:bg-muted" data-testid="discuss-dm-empty"><MessageCircle size={12} />{id ? 'Mulai percakapan' : 'Start a conversation'}</button>}
    </nav>
  );
};
